<template>
  <v-dialog v-model="dialog" :width="width" scrollable>
    <v-card class="rounded-lg">
      <v-card-title class="text-subtitle-1">
            {{ key ? 'Xem dữ liệu' : 'Tạo mới' }} {{ key || '' }}
            <v-spacer></v-spacer>
            <v-icon color="red" @click="dialog=false"> mdi-close
            </v-icon>
          </v-card-title>
      <v-card-text>
        <slot name="viewSection" :item="item" :selected="selected" :mode="(key ? 'view' : 'create')" 
         :onInput="inputHandler"></slot>
      </v-card-text>
      <v-card-actions v-if="showActions">
        <v-spacer></v-spacer>
        <v-btn color="grey" dark @click="dialog = false">Đóng</v-btn>
        <v-btn v-if="key" color="green" dark @click="submit">Cập nhật</v-btn>
        <v-btn v-else color="green" dark @click="submit">Tạo mới</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ViewDialog',
  data() {
    return {
      dialog: false,
      item: null,
      updatedItem: null,
      key: null
    }
  },
  props: {
    width: {
      type: [String, Number],
      default: '600px'
    },
    selected: {
      type: [String, Number, Object],
      default: null
    },
    showActions: {
      type: Boolean,
      default: false
    },
    
    updateHandler: {
      type: Function,
      default: null
    },
    createHandler: {
      type: Function,
      default: null
    }
  },
  computed: {
    mode() {
      return this.key ? 'view' : 'create'
    }
  },
  methods: {
    open(inputItem, key = null) {
      this.dialog = true
      this.item = inputItem
      this.key = key || null
    },
    setItem(inputItem) {
      alert("-----")
      this.item = { ...inputItem }
    },
    openCreate(defaultItem = null) {
      this.open(defaultItem, null)
    },
    submit() {
      switch(this.mode) {
        case 'create':
          this.createHandler(this.item).then(() => {
            this.$emit('reload')
            this.dialog = false
          })
          break;
        case 'view':
          this.updateHandler(this.key, this.item).then(() => {
            this.$emit('reload')
            this.dialog = false
          })
          break;
      }
      // alert('submit dialog ' + this.key)
      // this.$emit('submit', { item: this.item, key: this.key, mode: this.key ? 'update' : 'create' })
    },
    inputHandler(value) {
      this.item = { ...this.item, ...value }
    }
  }

}
</script>